<template>
  <div v-if="userData.userData">
    <Layout :onlyLogoHeader="true" :removePadding="true">
      <p style="color: var(--primary-color-blue); font-size: 14px; font-weight: 300;" class="text-center mt-10">
        {{ $t("qr_view.qr_text") }}
      </p>

      <!--Temporarily disabled-->
      <!--v-row justify="center" v-if="showQR" class="mt-2">
        <v-progress-circular
          :indeterminate="!countdown"
          :size="50"
          :width="5"
          :rotate="-90"
          :value="getValue()"
          color="primary"
        >
          {{ countdown }}
        </v-progress-circular>
      </v-row-->

      <!--Static QR. Temporarily enabled-->
      <v-row justify="center">
        <v-col cols="12" class="d-flex justify-center ma-2">
          <div :style="cssProps">
            <qr-code
              class="qr-code"
              :text="userData.userData.id"
              :size="qrSize"
              error-level="H"
              bg-color="#ffffff00"
              :color="'#0C0C0C'"
            ></qr-code>
          </div>
        </v-col>
      </v-row>

      <!--Temporarily disabled-->
      <!--v-row justify="center">
        <v-col cols="12" class="d-flex justify-center ma-10">
          <div :style="$vuetify.breakpoint.width > 400 ? cssProps : ''">
            <qr-code
              v-if="showQR && encodedJwt"
              class="qr-code"
              :text="encodedJwt"
              :size="qrSize"
              error-level="H"
              bg-color="#ffffff00"
              :color="'#0C0C0C'"
            ></qr-code>
            <v-progress-circular
              v-if="!showQR"
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
        </v-col>
      </v-row-->
      <v-row v-show="appleUrl && androidUrl" justify="center" class="mb-6 mx-10">
        <a class="mb-3" :href="androidUrl" target="_blank">
          <div class="d-flex justify-center align-center" style="background: var(--primary-color-blue); border-radius: 16px; height: 65px; width: 330px;">
            <v-img
              max-width="30"
              max-height="30"
              :src="googleWalletIcon"
            />
            <p class="ml-4 mt-4" style="color: white; font-size: 16px; font-weight: 300; height: 65px; line-height: 65px; text-align: center;">Añadir <span style="font-weight: 500;">Google Wallet</span></p>
          </div>
        </a>
        <a :href="appleUrl" download="pass.pkpass">
          <div class="d-flex justify-center align-center" style="background: var(--primary-color-blue); border-radius: 16px; height: 65px; width: 330px;">
            <v-img
              max-width="30"
              max-height="30"
              :src="appleWalletIcon"
            />
            <p class="ml-4 mt-4" style="color: white; font-size: 16px; font-weight: 300; height: 65px; line-height: 65px; text-align: center;">Añadir <span style="font-weight: 500;">Apple Wallet</span></p>
          </div>
        </a>
        
      </v-row>
      
      <v-row justify="center" class="mb-6">
        <v-col cols="auto">
          <p
            style="color: var(--primary-color-blue); font-size: 16px; font-weight: 500px; text-decoration: underline;"
            @click="$router.push({ name: routeNames.WALLET })"
          >{{ $t("qr_view.dismiss_text") }}</p>
        </v-col>
      </v-row>
    </Layout>
    <RedeemTagDialog ref="redeemTagDialog" />
  </div>
</template>

<script>
import Layout from "@/views/layouts/MainLayout";
import { mapState } from "vuex";
import { RequestService } from "../services/request.service";
import jwt from "jsonwebtoken";
import routeNames from "@/router/route-names";
import errorManager from "@/services/error.manager";
import RedeemTagDialog from "@/components/dialogs/RedeemTagDialog";

const requestService = new RequestService();
export default {
  data() {
    return {
      qrSize: 230,
      countdown: 60,
      intervalId: null,
      totalTime: 60,
      showQR: false,
      encodedJwt: null,
      routeNames: routeNames,
      appleWalletImage: require('@/assets/images/add_apple_wallet.png'),
      googleWalletImage: require('@/assets/images/add_google_wallet.png'),
      appleWalletIcon: require('@/assets/images/apple_wallet_icon.png'),
      googleWalletIcon: require('@/assets/images/google_wallet_icon.png'),
      appleUrl: null,
      androidUrl: null
    };
  },
  components: {
    Layout,
    RedeemTagDialog
  },
  computed: {
    ...mapState(["userData"]),
    ...mapState({
      showRedeemTagMessage: (state) => { 
        return (state.customization.customization.show_redeem_tag_message !== undefined) 
        ? state.customization.customization.show_redeem_tag_message 
        : false 
      }
    }),
    cssProps() {
      return {
        backgroundImage:
          "url(" + require("@/assets/images/qr_background.png") + ")",
        width: `${this.qrSize + 70}px`,
        height: `${this.qrSize + 70}px`,
        backgroundSize: "cover",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      };
    },
  },
  methods: {
    getValue() {
      return (this.countdown * 100) / this.totalTime;
    },
    encodeJWT() {
      // Temporarily not in use
      const now = window.moment();
      const futureDate = now.add(1, "minutes");
      const exp = futureDate.unix();

      const payload = {
        sub: this.userData.userData.id,
        exp: exp,
      };

      this.encodedJwt = jwt.sign(payload, this.userData.userData.public_seed);
    },
    startCountdown() {
      this.intervalId = setInterval(async () => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          this.showQR = false;
          const context = this;
          clearInterval(this.intervalId);
          await requestService.getUserData(context);
          // await this.encodeJWT();
          // this.countdown = this.totalTime;
          // this.showQR = true;
          // this.startCountdown();
        }
      }, 1000);
    },
    async getPassesUrlsCall(context) {
      await requestService 
        .getPassesUrls(context, this.userData.userData.id)
        .then((urls) => {
          this.appleUrl = urls.ios_url
          this.androidUrl = urls.android_url
        })
        .catch((error) => {
          errorManager.manageError(context, error);
        })
    }
  },
  async mounted() {
    const context = this;
    await requestService.getUserData(context);
    await context.getPassesUrlsCall(context);
    // this.showQR = true;
    // await this.encodeJWT();
    // this.startCountdown();
    this.$nextTick(() => {
      if (this.showRedeemTagMessage) {        
        if (this.userData != null) {
          if (this.userData.userData.tag_id == null) {
            this.$refs.redeemTagDialog.dialog = true;
          }
        }
      }
    });
  },
  beforeUnmount() {
    // clearInterval(this.intervalId);
  },
};
</script>
